import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { adminService } from "../../../services/index";
import QuickPayHeader from "./view/_header";
import QuickPayContent from "./e_content";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  loadingButton: {
    marginTop: "15% !important"
  }
}))

export default function QuickpayLanding() {
  let classes = useStyles();
  let languageCode = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const [data, setData] = useState();

  return (
    <>
        <>
          <QuickPayHeader  />
          <QuickPayContent />
        </>
    </>
  );
}